<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10" md="9" lg="8" xl="9">
        <v-card elevation="8" class="pa-6 text-center" style="min-height: 75vh;">

          <!-- Título -->
          <v-card-title class="headline font-weight-bold">
            REGISTRO DE COMPROBANTES
          </v-card-title>

          <!-- Subtítulo -->
          <v-card-subtitle class="mb-6 text-uppercase">
            TIPO DE REGISTRO
          </v-card-subtitle>

          <!-- Botones superiores -->
          <v-row dense>
            <!-- VENTAS -->
            <v-col cols="12" sm="6" class="mb-4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    large
                    color="green darken-1"
                    dark
                    class="big-button"
                    v-bind="attrs"
                    v-on="on"
                    @click="accion('ventas')"
                  >
                    VENTAS
                  </v-btn>
                </template>
                <span>Registrar o consultar ventas realizadas</span>
              </v-tooltip>
            </v-col>

            <!-- COMPRAS -->
            <v-col cols="12" sm="6" class="mb-4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    large
                    color="grey darken-1"
                    dark
                    class="big-button"
                    v-bind="attrs"
                    v-on="on"
                    @click="registrarCompras();"
                  >
                    COMPRAS
                  </v-btn>
                </template>
                <span>Registrar o consultar compras realizadas</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <!-- Botones inferiores -->
          <v-row dense>
            <!-- INGRESOS -->
            <v-col cols="12" sm="6" class="mb-4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    large
                    color="cyan darken-4"
                    dark
                    class="big-button"
                    v-bind="attrs"
                    v-on="on"
                    @click="accion('ingresos')"
                  >
                    INGRESOS
                  </v-btn>
                </template>
                <span>Registrar ingresos adicionales o especiales</span>
              </v-tooltip>
            </v-col>

            <!-- EGRESOS -->
            <v-col cols="12" sm="6" class="mb-4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    large
                    color="grey darken-3"
                    dark
                    class="big-button"
                    v-bind="attrs"
                    v-on="on"
                    @click="accion('egresos')"
                  >
                    EGRESOS
                  </v-btn>
                </template>
                <span>Registrar egresos o salidas de fondos</span>
              </v-tooltip>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import router from "@/router/index";


export default {
  name: 'RegistroComprobantes',
  methods: {
    accion(tipo) {
      console.log('Acción seleccionada:', tipo);
    },
    registrarCompras(){
            router.push("/registro_compra");
    }
  }
}
</script>

<style scoped>
.headline {
  font-size: 32px;
}

.v-btn.big-button {
  font-size: 20px;
  padding: 24px 16px;
  min-height: 70px;
}

.v-card {
  width: 100%;
}

@media (max-width: 600px) {
  .headline {
    font-size: 24px;
  }
  .v-btn.big-button {
    font-size: 18px;
    padding: 20px 12px;
    min-height: 60px;
  }
}
</style>
